<template>
  <a-layout>
    <vxe-table
      border
      stripe
      round
      show-overflow
      show-header-overflow
      :checkbox-config="{checkRowKeys: defaultSelecteRows, highlight: true,checkField: 'checked', trigger: 'row'}"
      :radio-config="{labelField: 'name'}"
      :column-config="{resizable: true}"
      :row-config="{isCurrent: true, isHover: true}"
      :export-config="{}"
      :keyboard-config="{isArrow: true}"
      align="center"
      ref="table"
      :data="data"
      :loading="loading"
      :height="scrollY"
      size="mini">
      <vxe-table-column type="checkbox" width="60"/>
      <vxe-table-column title="business.label.index" type="seq" width="60"/>
      <vxe-table-column field="barcode.no" sortable title="business.label.barcode" width="100"/>
      <vxe-table-column field="customer.no" sortable title="business.label.customerNo" width="150"/>
      <vxe-table-column field="customer.name" sortable title="business.label.customerName" width="150"/>
      <vxe-table-column field="dispatch.wave" sortable title="business.label.wave" width="100"/>
      <vxe-table-column field="order.no" sortable title="business.label.orderNo" width="120"/>
      <vxe-table-column field="pickingOrder.no" sortable title="business.label.pickingOrderNo" width="150"/>
      <vxe-table-column field="type" sortable title="business.label.type" width="150"/>
    </vxe-table>
  </a-layout>
</template>
<script>
import Vue from 'vue'
import { SCREEN_HEIGHT } from '@/store/mutation-types'
import { findAll } from '@/api/Api'
import { getOutBoundCaseData } from '@/pdaView/utils'

export default {
    name: 'CaseTag',
    data() {
      return {
        defaultSelecteRows: [],
        loading: false,
        data: [],
        scrollY: Vue.ls.get(SCREEN_HEIGHT) * (0.845)// 表格竖向滚动条,减去的数值是页面其他元素的高度
      }
    },
    methods: {

      getData(body) {
        this.loading = true
        findAll('shipmentCommandBarcodeFactory', body).then(res => {
          if (res.success) {
            this.data = res.result
          }
        }).finally(() => {
          this.loading = false
        })
      },
      print() {
        let list = this.$refs.table.getCheckboxRecords()
        _.forEach(list, item => {
          let body = {
            'query.no': 'casePickingTagPrint',
            'sql': null,
            'args': {
              'barcodeNo': item.barcode.no,
              pickingOrderNo: null
            }
          }
          getOutBoundCaseData(body)
        })
      }
    },
    mounted() {

    }
  }
</script>